import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ProgressBarModule } from "primeng/progressbar";

@Component({
  selector: "loader",
  standalone: true,
  template: ` <div class="t-inputWrap-loader" role="alert"></div> `,
  imports: [ProgressBarModule, CommonModule],
})
export class LoaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
